export enum StatusAgendamento {
  confirmadoCliente = 'Confirmado Cliente',
  confirmadoAdm = 'Confirmado Administrador',
  atendido = 'Atendido',
  naoAtendido = 'Não Atendido',
}
